module.exports = __webpack_public_path__ + "aa4226b4.png";